import Repository from './../Repository';

const resource = 'admin/registrations';

export default {
    get(payload){return Repository.get(`${resource}`, payload);},
    reject(id)  {return Repository.post(`${resource}/${id}/reject`);},
    approve(payload, id) {return Repository.post(`${resource}/${id}/approve`, payload);},
}